import { Stack, Typography } from '@mui/material'
import React, { FC, ReactNode } from 'react'

interface Props {
  emoji?: string
  title: string
  description?: string
  bottomAction?: ReactNode
}

const EmptyList: FC<Props> = ({ emoji, title, description, bottomAction }) => {
  return (
    <Stack px={2} spacing={1} flex={1} justifyContent="center" alignItems="center">
      <Typography fontSize={30}>{emoji || '🙄'}</Typography>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="caption" textAlign="center" fontSize={15}>
        {description}
      </Typography>
      {bottomAction && bottomAction}
    </Stack>
  )
}

export default EmptyList
